<template>
    <div class="uploader">
        <veui-uploader
            v-model="list"
            theme="ai"
            :entries="entries"
            :max-count="maxCount"
            :controls="controls"
            request-mode="custom"
            :upload="upload"
            type="image"
            @snapshot="handleSnapshot"
            @zoomin="handlePreview"
            @change="handleChange"
        />
        <span class="uploader-help">单张照片大小不超过2M，格式为png、jpg、jpeg，最多4张</span>
        <veui-lightbox
            :open.sync="showPreview"
            :datasource="previewDatasource"
            overlay-class="lightbox-preview"
            indicator="none"
            :escapable="false"
        />
    </div>
</template>

<script>
import {nanoid} from 'nanoid';
import {Uploader, Lightbox} from 'veui';
import 'veui-theme-dls-icons/zoom-in';
import 'veui-theme-dls-icons/trash';
import 'veui-theme-dls-icons/track-cut';

export default {
    name: 'Uploader',
    props: {
        maxCount: {
            type: Number,
            default: 1
        },
        value: {
            type: Array,
            default: () => []
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    components: {
        'veui-uploader': Uploader,
        'veui-lightbox': Lightbox
    },
    watch: {
        value(val) {
            this.list = val;
        },
        showPreview(val) {
            const dialogEl = document.querySelector('.feedback-dialog');
            if (val) {
                dialogEl.style.background = 'transparent';
            }
            else {
                dialogEl.style.background = 'rgba(0, 0, 0, .6)';
            }
        }
    },
    data() {
        return {
            list: this.value,
            entries(defaultEntries) {
                return [
                    {
                        name: 'snapshot',
                        icon: 'track-cut',
                        label: '直接截图'
                    },
                    ...defaultEntries
                ];
            },
            controls() {
                return [
                    {
                        name: 'zoomin',
                        icon: 'zoom-in',
                        label: '预览'
                    },
                    {
                        name: 'remove',
                        icon: 'trash',
                        label: '移除'
                    }
                ];
            },
            upload: (file, {onload}) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    const result = e.target.result;
                    onload({
                        success: true,
                        name: file.name,
                        size: file.size,
                        image_type: file.type,
                        src: result,
                        key: nanoid()
                    });
                };
                reader.readAsDataURL(file);
            },
            showPreview: false,
            previewDatasource: []
        };
    },
    computed: {

    },
    methods: {
        handleChange(value) {
            this.$emit('change', value);
        },
        handleSnapshot() {
            this.$emit('snapshot');
        },
        handlePreview(item) {
            this.showPreview = true;
            this.previewDatasource = [{src: item.src}];
        }
    },
    mounted() {
    // 组件挂载后钩子函数
    }
};
</script>

<style scoped lang="less">
.uploader {
    /deep/ .veui-ai-uploader-list-media-container {
        width: 152px;
        height: 152px;
        background-color: var(---T1, rgba(58, 85, 166, 0.07)) !important;
    }
    /deep/ .veui-ai-uploader-input-label-media-has-entries{
        * {
            display: none;
        }
    }
    /deep/ .veui-ai-uploader-entries-container  {
        opacity: 1;
    }
    /deep/ .veui-ai-button {
        color: #282C33;
        background: transparent;
        &:hover {
            .veui-ai-button-native>span{
                color: #545B66;
            }
        }
    }
    /deep/ .veui-ai-uploader-list-media {
        &-item {
            width: 152px;
            height: 152px;

        }
    }
    /deep/ .veui-ai-uploader-list-media-mask {
        background-color: transparent;
        padding: 8px;
        .veui-ai-button {
            padding: 4px;
            border-radius: var(--Radius-r1, 6px);
            background: rgba(0, 0, 0, 0.60);
            margin-left: 8px;
        }
        .veui-ai-button-native {
            width: 16px;
            height: 16px;
        }
    }
    &-help {
        color: var(---G7, #848B99);
        font-size: 12px;
        line-height: 16px; /* 133.333% */
    }
}
.lightbox-preview {
    padding: 0;
    /deep/ .veui-ai-lightbox-viewport-content {
        padding: 64px 88px;
    }
    /deep/ .veui-ai-lightbox-head-close.veui-ai-button {
        color: #fff;
        position: absolute;
        top: 24px;
        right: 24px;
        z-index: 110;
        border-radius: var(--Radius-r1, 6px);
        background: var(----hover, rgba(0, 0, 0, 0.50));
        width: 32px;
        height: 32px;
        padding: 8px;
        .veui-ai-icon {
            height: 16px;
        }
    }
}
</style>